import axios from "axios";

export default {
  async getTreeData(treeType) {
    try {
      const { data } = await axios.get(`/coffee/${treeType}`, {
        // params: requestParams
      });
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async createTreeType(treeType, treeData) {
    try {
      const { data } = await axios.post(`/coffee/${treeType}`, treeData);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async updateTreeType(id, treeType, treeData) {
    try {
      const { data } = await axios.put(`/coffee/${treeType}/${id}`, treeData);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async deleteTreeType(treeType, id) {
    try {
      const { data } = await axios.delete(`/coffee/${treeType}/${id}`);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async getCoffeeVariety(dataOptions) {
    try {
      const requestParams = {
        page: dataOptions.page,
        limit: dataOptions.itemsPerPage,
        coffeeSpecies: dataOptions.coffeeSpecies,
      };
      if (dataOptions.sortBy.length) {
        requestParams.name = dataOptions.sortBy[0];
        requestParams.sortingType = dataOptions.sortDesc[0] ? "DESC" : "ASC";
      }
      const { data } = await axios.get(`/coffee/coffeeVariety`, {
        params: requestParams,
      });
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async createCoffeeVariety(coffeeData) {
    try {
      const { data } = await axios.post(`/coffee/coffeeVariety`, coffeeData);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async deleteCoffeeVariety(id) {
    try {
      const { data } = await axios.delete(`/coffee/coffeeVariety/${id}`);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async getCoffeeSpecies(dataOptions) {
    try {
      const requestParams = {
        page: dataOptions.page,
        limit: dataOptions.itemsPerPage,
      };
      if (dataOptions.sortBy.length) {
        requestParams.name = dataOptions.sortBy[0];
        requestParams.sortingType = dataOptions.sortDesc[0] ? "DESC" : "ASC";
      }
      const { data } = await axios.get(`/coffee/coffeeSpecies`, {
        params: requestParams,
      });
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async getMemberDataCoffeeSpecies() {
    try {
      const { data } = await axios.get(`/coffee/memberData/coffeeSpecies`);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },
  async getMemberDataCoffeeVariety(dataOptions) {
    try {
      const requestParams = {
        coffeeSpecies: dataOptions.coffeeSpecies,
      };

      const { data } = await axios.get(`/coffee/memberData/coffeeVariety`, {
        params: requestParams,
      });
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },
  async createCoffeeSpecies(speciesData) {
    try {
      const { data } = await axios.post(`/coffee/coffeeSpecies`, speciesData);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async deleteCoffeeSpecies(id) {
    try {
      const { data } = await axios.delete(`/coffee/coffeeSpecies/${id}`);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async updateCoffeeSpecies(id, speciesData) {
    try {
      const { data } = await axios.put(
        `/coffee/coffeeSpecies/${id}`,
        speciesData
      );
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async updateCoffeeVariety(id, varietyData) {
    try {
      const { data } = await axios.put(
        `/coffee/coffeeVariety/${id}`,
        varietyData
      );
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response);
    }
  },

  async getCoffeeTypes() {
    try {
      const { data } = await axios.get(`/coffee/coffee-types`);
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err.response ?? err.request);
    }
  },

    async getCoffeeData(dataOptions, search) {
        const url = `/coffee/buying-station/processing-batch-for-dds`
        const requestParams = {
            page: dataOptions.page,
            limit: dataOptions.itemsPerPage,
            searchPhrase: search,
        }

        // if(dataOptions.sortBy.length){
        //     requestParams.orderField = dataOptions.sortBy[0]
        //     requestParams.order = dataOptions.sortDesc[0]? 'DESC': 'ASC'
        // }


        try{
            const {data} = await axios.get(url, {
                params: requestParams
            })
            return Promise.resolve(data);
        }catch(err){
            return Promise.reject(err.response)
        }
    },
}
